module.exports = __webpack_public_path__ + "static/media/person.df024dfb.svg";